import axios from "axios";
import {apiConfig} from "../api-config";

export class AuthService {
    private readonly url: string;

    constructor() {
        this.url = apiConfig.AUTH_URL;
    }

    login = async (username: string, password: string) => {
        return new Promise<any>((resolve, reject) => {
            axios.post<any>(this.url + '/login', { username, password })
                .then(response => {
                    resolve(response.data)
                })
                .catch(reject);
        })
    }

    logout = async () => {
        return new Promise((resolve, reject) => {
            axios.get(this.url + "/logout")
                .then(resolve)
                .catch(reject);
        })
    }
}
